import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import Button from '../../../components/Library/Button';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../../components/Library/Modal';
import InlineLoadingSpinner from '../../../components/LoadingSpinner/InlineLoadingSpinner';
import { useAccountContext } from '../../../contexts/AccountContext';
import { ScimIntegration, useSCIM_IntegrationsApi } from '../../../middle_auth_api';

const ScimIntegrationsDelete: React.FC = () => {
  const scimIntegrationsApi = useSCIM_IntegrationsApi()
  const accountContext = useAccountContext();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const context: ScimIntegration | undefined = useOutletContext();

  const deleteMutation = useMutation(async () => {
    await scimIntegrationsApi.delete_scim_integration_by_id(undefined, {
      params: {
        id: context!.id
      }
    })
  }, {
    onSuccess: () => {
      void queryClient.invalidateQueries(['scim-integrations', accountContext.currentAccount?.id]);
      navigate('../..');
    }
  });

  const closeModal = () => {
    navigate('..');
  }

  return <>
    <Modal show closeModal={closeModal}>
      <ModalHeader closeModal={closeModal}>Delete: {context?.name}</ModalHeader>
      <ModalBody>
        <div className='p-4'>
          {deleteMutation.isLoading
            ? <InlineLoadingSpinner />
            : <>Do you really want to delete the SCIM Integration &quot;{context?.name}&quot;?</>}
        </div>
      </ModalBody>
      {!deleteMutation.isLoading && <ModalFooter>
        <Button variant='secondary' onClick={closeModal}>No</Button>
        <Button variant='danger' onClick={() => deleteMutation.mutate()}>Yes</Button>
      </ModalFooter>}
    </Modal>
  </>
};

export default ScimIntegrationsDelete;